<template>
  <v-dialog v-model="display" persistent max-width="350">
    <v-card class="mx-auto secondary">
      <CardHeader :title="title" icon="mdi-close" @iconClicked="reject" />
      <v-card-subtitle v-if="question" class="pt-5 pb-2 px-2">{{
        question
      }}</v-card-subtitle>
      <v-card-text v-if="questionDetails" class="pt-0 pb-2 px-2">
        <v-row
          no-gutters
          v-for="questionDetail in questionDetails"
          :key="questionDetail"
        >
          <v-col>
            {{ questionDetail }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn v-if="!disableReject" text class="text-left" @click="reject()">
          {{ rejectText ? rejectText : "Nej" }}
        </v-btn>
        <v-btn class="text-right" @click="accept()">
          {{ acceptText ? acceptText : "Ja" }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CardHeader from "@/components/templates/CardHeader.vue";

export default {
  components: {
    CardHeader
  },
  props: {
    display: { type: Boolean, required: true },
    title: { type: String, required: true },
    question: String,
    questionDetails: Array,
    acceptText: String,
    rejectText: String,
    disableReject: Boolean
  },
  data() {
    return {};
  },
  methods: {
    reject() {
      this.$emit("rejected");
    },
    accept() {
      this.$emit("accepted");
    }
  }
};
</script>
